import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  ToggleRadioButtonGroup,
  type ToggleRadioButtonGroupProps,
} from '~/components/elements/ToggleRadioButtonGroup'

import { type QuestionDataType } from '../utils'

export type QuestionDataTypeSwitcherProps = {
  onChange: (dataType: QuestionDataType) => void
  value: QuestionDataType
}

export const QuestionDataTypeSwitcher = ({
  onChange,
  value,
}: QuestionDataTypeSwitcherProps) => {
  const { t } = useTranslation()
  const attributes = React.useMemo<
    ToggleRadioButtonGroupProps<QuestionDataType>['attributes']
  >(
    () => [
      { text: t('ptype'), value: 'macromill' },
      { text: t('qtype'), value: 'intage' },
    ],
    [t],
  )

  return (
    <ToggleRadioButtonGroup
      attributes={attributes}
      value={value}
      onChange={onChange}
    />
  )
}
